// extracted by mini-css-extract-plugin
module.exports =  {"popupFieldComponent":"Claims_popupFieldComponent__7yxcy","contactDetailsLink":"Claims_contactDetailsLink__ASc2D"};